'use client';

import { useFeatureFlags } from '@Contexts/FeatureFlags';
import * as PageProductStore from '@Stores/PageProduct';
import LayoutMain from '@Layouts/LayoutMain';
import Page404 from '@Pages/Page404';
import usePage from '@Queries/usePage';
import Page from '@Components/Page';
import PagePickPair from './pages/PagePick&Pair';
import PageProductConstructor from './pages/PageProductConstructor';
import PageProduct from './pages/PageProduct';

import type { FC, HTMLAttributes } from 'react';
import type { PageProductData, ProductClassification } from './typings';

interface PageProductContainerProps {
  page?: PageProductData;
}

export interface PageProductProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const PageProductContainer: FC<PageProductContainerProps> = (props) => {
  const pageQuery = usePage<PageProductData>();
  const page = props.page || pageQuery.data;
  const { constructorProductPageTemplate } = useFeatureFlags();

  if (!page?.product) return <Page404 />;

  PageProductStore.init(page);
  const isPickPair = !!page.set;
  const classifications: ProductClassification[] = ['ribble', 'brera'];
  const hasClassification = classifications.some((classification) =>
    page.classifications?.includes(classification),
  );
  const isOutdatedView =
    (page.isConfigurator && (page.isModular || hasClassification)) || !!page.mediaGallery;

  const renderPage = () => {
    if (isPickPair) return <PagePickPair />;
    if (!constructorProductPageTemplate) return <PageProduct />;
    return isOutdatedView ? <PageProduct /> : <PageProductConstructor />;
  };

  return (
    <LayoutMain>
      <Page>{renderPage()}</Page>
    </LayoutMain>
  );
};

export default PageProductContainer;
